/* Shop the Look – lazy video + filters + lightbox + shop alles (Claude, 2026-09) */
(function () {
  if (customElements.get('stl-video')) return;

  let current = null; // only one video with sound at a time

  class StlVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('.look__sound');
      if (!this.video) return;
      this.loaded = false;
      this.autoplay = this.hasAttribute('autoplay');

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { this.load(); if (this.autoplay) this.play(); }
          else if (!this.video.paused) { this.video.pause(); }
        });
      }, { rootMargin: '200px 0px', threshold: 0.15 });
      this.observer.observe(this);
      if (this.hasAttribute('eager')) { this.load(); if (this.autoplay) this.play(); }

      this.video.addEventListener('play', () => this.setAttribute('playing', ''));
      this.video.addEventListener('pause', () => this.removeAttribute('playing'));
      this.video.addEventListener('click', (ev) => {
        ev.preventDefault();
        this.load();
        // Telefoon/tablet: meteen de native fullscreen-speler (zonder geluid); desktop: lightbox
        if (this.enterNativeFullscreen()) return;
        if (window.StlLightbox) { window.StlLightbox.openFrom(this); return; }
        if (this.video.paused) this.play(); else this.video.pause();
      });
      if (this.button) {
        this.button.addEventListener('click', (ev) => {
          ev.preventDefault(); ev.stopPropagation();
          this.load();
          const unmute = this.video.muted;
          if (unmute && current && current !== this) current.mute();
          this.video.muted = !unmute;
          this.toggleAttribute('unmuted', unmute);
          this.button.setAttribute('aria-label', unmute ? 'Geluid uit' : 'Geluid aan');
          current = unmute ? this : null;
          if (this.video.paused) this.play();
        });
      }
    }
    // Native fullscreen op touch-apparaten (iOS: webkitEnterFullscreen, Android: requestFullscreen), zonder geluid. Geeft true als gestart.
    enterNativeFullscreen() {
      const v = this.video;
      const touch = window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches;
      if (!touch) return false;
      const ios = typeof v.webkitEnterFullscreen === 'function';
      if (!ios && !v.requestFullscreen) return false;
      const done = () => { if (this.autoplay && v.paused) this.play(); };
      const fallback = () => { if (window.StlLightbox) window.StlLightbox.openFrom(this); };
      try {
        if (ios) {
          const go = () => {
            try { v.webkitEnterFullscreen(); } catch (e) { fallback(); return; }
            v.addEventListener('webkitendfullscreen', done, { once: true });
          };
          this.play();
          if (v.readyState >= 1) go();
          else v.addEventListener('loadedmetadata', go, { once: true });
          return true;
        }
        const onChange = () => { if (!document.fullscreenElement) { document.removeEventListener('fullscreenchange', onChange); done(); } };
        document.addEventListener('fullscreenchange', onChange);
        this.play();
        const p = v.requestFullscreen();
        if (p && p.catch) p.catch(() => { document.removeEventListener('fullscreenchange', onChange); fallback(); });
        return true;
      } catch (e) { return false; }
    }
    load() {
      if (this.loaded) return;
      this.loaded = true;
      this.video.querySelectorAll('source[data-src]').forEach((s) => { s.src = s.dataset.src; });
      this.video.load();
    }
    play() {
      const p = this.video.play();
      if (p && p.catch) p.catch(() => {});
    }
    mute() {
      this.video.muted = true;
      this.removeAttribute('unmuted');
      if (this.button) this.button.setAttribute('aria-label', 'Geluid aan');
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
  }
  customElements.define('stl-video', StlVideo);

  /* ---------- Lightbox: foto's en video's schermvullend (klik/tik), sluiten via tik, X, Esc, swipe of terug-knop ---------- */
  const ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  const ICON_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
  const ICON_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';

  const Lightbox = {
    el: null, stage: null, media: null, items: [], index: 0, origin: null, lastFocus: null, pushed: false, isOpen: false, closing: false,

    build() {
      if (this.el) return;
      const el = document.createElement('div');
      el.className = 'stl-lightbox';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'Vergrote weergave');
      el.hidden = true;
      el.innerHTML =
        '<div class="stl-lightbox__stage"></div>' +
        '<p class="stl-lightbox__hint">Knijp of dubbeltik om in te zoomen</p>' +
        '<button class="stl-lightbox__nav stl-lightbox__nav--prev" type="button" aria-label="Vorige">' + ICON_PREV + '</button>' +
        '<button class="stl-lightbox__nav stl-lightbox__nav--next" type="button" aria-label="Volgende">' + ICON_NEXT + '</button>' +
        '<button class="stl-lightbox__close" type="button" aria-label="Sluiten">' + ICON_CLOSE + '</button>' +
        '<div class="stl-lightbox__caption"><span class="stl-lightbox__title"></span><span class="stl-lightbox__brands"></span><span class="stl-lightbox__count"></span><a class="stl-lightbox__link" hidden></a></div>';
      document.body.appendChild(el);
      this.el = el;
      this.stage = el.querySelector('.stl-lightbox__stage');
      this.prevBtn = el.querySelector('.stl-lightbox__nav--prev');
      this.nextBtn = el.querySelector('.stl-lightbox__nav--next');
      this.closeBtn = el.querySelector('.stl-lightbox__close');
      this.titleEl = el.querySelector('.stl-lightbox__title');
      this.brandsEl = el.querySelector('.stl-lightbox__brands');
      this.countEl = el.querySelector('.stl-lightbox__count');
      this.linkEl = el.querySelector('.stl-lightbox__link');

      this.closeBtn.addEventListener('click', () => this.close());
      this.prevBtn.addEventListener('click', (ev) => { ev.stopPropagation(); this.go(-1); });
      this.nextBtn.addEventListener('click', (ev) => { ev.stopPropagation(); this.go(1); });

      // Sluiten: alleen via de donkere achtergrond, het kruis, Esc, swipe omlaag (niet ingezoomd) of de terug-knop.
      el.addEventListener('click', (ev) => {
        if (this.dragged) { this.dragged = false; return; }
        const t = this.pressTarget || ev.target;
        // Foto: klik (muis) = in-/uitzoomen op dat punt; touch gebruikt dubbeltik (zie onEnd)
        if (this.media && t === this.media && this.media.tagName === 'IMG') {
          if (this.lastPointerType !== 'touch' && this.lastPointerType !== 'pen') this.toggleZoom(ev.clientX, ev.clientY);
          return;
        }
        if (t !== el && t !== this.stage) return;
        this.close();
      });

      // Muiswiel / trackpad = zoomen rond de cursor
      this.stage.addEventListener('wheel', (ev) => {
        if (!this.media || this.media.tagName !== 'IMG') return;
        ev.preventDefault();
        const factor = Math.exp(-ev.deltaY * (ev.deltaMode === 1 ? 0.05 : 0.0025));
        this.zoomTo(this.z.s * factor, ev.clientX, ev.clientY, false);
      }, { passive: false });

      // Pointer-gestures: pinch (2 vingers), pan (ingezoomd), swipe (niet ingezoomd), dubbeltik
      const pointers = new Map();
      let mode = 'none', start = null, pinch = null, lastTap = { t: 0, x: 0, y: 0 };
      const dist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
      const mid = (a, b) => ({ x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 });
      const onStart = (ev) => {
        if (ev.target.closest('.stl-lightbox__caption, .stl-lightbox__nav, .stl-lightbox__close')) return;
        if (ev.pointerType === 'mouse' && ev.button !== 0) return;
        this.lastPointerType = ev.pointerType;
        this.pressTarget = ev.target; // pointer capture hertarget latere events naar el
        pointers.set(ev.pointerId, { x: ev.clientX, y: ev.clientY });
        try { el.setPointerCapture(ev.pointerId); } catch (e) {}
        const isImg = this.media && this.media.tagName === 'IMG';
        if (pointers.size === 2 && isImg) {
          const [a, b] = Array.from(pointers.values());
          pinch = { d: dist(a, b), m: mid(a, b), s: this.z.s, tx: this.z.tx, ty: this.z.ty };
          mode = 'pinch'; start = null;
          this.el.style.background = '';
          if (this.z.s === 1 && this.media) this.media.style.transform = '';
          this.stage.setAttribute('data-drag', '');
          return;
        }
        if (pointers.size !== 1) return;
        start = { x: ev.clientX, y: ev.clientY, tx: this.z.tx, ty: this.z.ty, moved: false, t: Date.now() };
        if (isImg && this.z.s > 1) mode = 'pan';
        else if (ev.pointerType !== 'mouse') mode = 'swipe';
        else mode = 'none';
        if (mode !== 'none') this.stage.setAttribute('data-drag', '');
      };
      const onMove = (ev) => {
        if (!pointers.has(ev.pointerId)) return;
        pointers.set(ev.pointerId, { x: ev.clientX, y: ev.clientY });
        if (mode === 'pinch' && pointers.size === 2 && pinch) {
          const [a, b] = Array.from(pointers.values());
          const m = mid(a, b);
          const s = Math.min(this.maxZoom, Math.max(1, pinch.s * dist(a, b) / pinch.d));
          // punt onder het startmidden blijft onder de vingers, plus verschuiving van het midden
          const p = this.toImagePoint(pinch.m.x, pinch.m.y, pinch.s, pinch.tx, pinch.ty);
          this.setZoom(s, m.x - p.x * s, m.y - p.y * s, false);
          return;
        }
        if (!start) return;
        const dx = ev.clientX - start.x, dy = ev.clientY - start.y;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) start.moved = true;
        if (mode === 'pan') {
          this.setZoom(this.z.s, start.tx + dx, start.ty + dy, false);
        } else if (mode === 'swipe' && this.media) {
          if (Math.abs(dy) > Math.abs(dx)) {
            const f = Math.max(0, 1 - Math.abs(dy) / 500);
            this.media.style.transform = 'translateY(' + dy + 'px) scale(' + (0.9 + 0.1 * f) + ')';
            this.el.style.background = 'rgba(14,14,14,' + (0.95 * (0.35 + 0.65 * f)) + ')';
          } else {
            this.media.style.transform = 'translateX(' + dx * 0.6 + 'px)';
          }
        }
      };
      const onEnd = (ev) => {
        if (!pointers.has(ev.pointerId)) return;
        pointers.delete(ev.pointerId);
        try { el.releasePointerCapture(ev.pointerId); } catch (e) {}
        const flag = () => { this.dragged = true; setTimeout(() => { this.dragged = false; }, 200); };
        if (mode === 'pinch') {
          if (pointers.size < 2) {
            this.stage.removeAttribute('data-drag');
            if (this.z.s < 1.08) this.setZoom(1, 0, 0, true); else this.setZoom(this.z.s, this.z.tx, this.z.ty, true);
            mode = 'none'; pinch = null; start = null; flag();
          }
          return;
        }
        if (!start) return;
        const dx = ev.clientX - start.x, dy = ev.clientY - start.y;
        this.stage.removeAttribute('data-drag');
        this.el.style.background = '';
        if (mode === 'pan') {
          this.setZoom(this.z.s, this.z.tx, this.z.ty, true); // klemt netjes terug binnen beeld
          if (start.moved) flag();
        } else if (mode === 'swipe') {
          if (this.media) this.media.style.transform = '';
          if (Math.abs(dy) > 70 && Math.abs(dy) > Math.abs(dx)) { flag(); mode = 'none'; start = null; this.close(); return; }
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) && this.items.length > 1) { flag(); mode = 'none'; start = null; this.go(dx < 0 ? 1 : -1); return; }
          if (start.moved) flag();
        }
        // Dubbeltik (touch) op een foto = in-/uitzoomen
        if (!start.moved && ev.pointerType !== 'mouse' && this.media && this.media.tagName === 'IMG' && this.pressTarget === this.media) {
          const now = Date.now();
          if (now - lastTap.t < 320 && Math.hypot(ev.clientX - lastTap.x, ev.clientY - lastTap.y) < 40) {
            this.toggleZoom(ev.clientX, ev.clientY); lastTap.t = 0; flag();
          } else { lastTap = { t: now, x: ev.clientX, y: ev.clientY }; }
        }
        if (!start.moved && ev.pointerType !== 'mouse' && this.pressTarget === this.media) flag(); // tik op de foto sluit niet
        mode = 'none'; start = null;
      };
      el.addEventListener('pointerdown', onStart);
      el.addEventListener('pointermove', onMove);
      el.addEventListener('pointerup', onEnd);
      el.addEventListener('pointercancel', onEnd);
      window.addEventListener('resize', () => { if (this.isOpen) { this.setZoom(this.z.s, this.z.tx, this.z.ty, false); this.positionClose(); } });

      document.addEventListener('keydown', (ev) => {
        if (!this.isOpen) return;
        if (ev.key === 'Escape') { ev.preventDefault(); this.close(); }
        else if (ev.key === 'ArrowRight') { this.go(1); }
        else if (ev.key === 'ArrowLeft') { this.go(-1); }
        else if (ev.key === 'Tab') { // focus binnen de lightbox houden
          const f = Array.from(el.querySelectorAll('button:not([hidden]), a:not([hidden]), video')).filter((n) => n.offsetParent !== null);
          if (!f.length) return;
          const first = f[0], last = f[f.length - 1];
          if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
          else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
        }
      });
      window.addEventListener('popstate', () => { if (this.isOpen && this.pushed) { this.pushed = false; this.close(); } });
    },

    /* ---- Zoom (alleen foto's): transform = translate(tx,ty) scale(s), oorsprong = midden van het beeld ---- */
    z: { s: 1, tx: 0, ty: 0 }, maxZoom: 4, lastPointerType: 'mouse',
    center() { const r = this.stage.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; },
    // schermpunt → punt op de ongeschaalde foto (t.o.v. het midden)
    toImagePoint(cx, cy, s, tx, ty) { const c = this.center(); return { x: (cx - c.x - tx) / s, y: (cy - c.y - ty) / s }; },
    setZoom(s, tx, ty, animate) {
      if (!this.media || this.media.tagName !== 'IMG') return;
      s = Math.min(this.maxZoom, Math.max(1, s));
      const w = this.media.clientWidth * s, h = this.media.clientHeight * s;
      const r = this.stage.getBoundingClientRect();
      const mx = Math.max(0, (w - r.width) / 2), my = Math.max(0, (h - r.height) / 2);
      tx = Math.min(mx, Math.max(-mx, tx)); ty = Math.min(my, Math.max(-my, ty));
      if (s === 1) { tx = 0; ty = 0; }
      this.z = { s, tx, ty };
      this.media.style.transition = animate ? 'transform .25s cubic-bezier(.22,1,.36,1)' : 'none';
      this.media.style.transform = s === 1 ? '' : 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')';
      const wasZoomed = this.el.classList.contains('is-zoomed');
      this.el.classList.toggle('is-zoomed', s > 1);
      if (wasZoomed !== (s > 1)) this.positionClose();
      if (animate) setTimeout(() => { if (this.media) this.media.style.transition = ''; }, 260);
    },
    zoomTo(s, cx, cy, animate) {
      // punt onder de cursor/vinger blijft op zijn plek
      const p = this.toImagePoint(cx, cy, this.z.s, this.z.tx, this.z.ty);
      const c = this.center();
      s = Math.min(this.maxZoom, Math.max(1, s));
      this.setZoom(s, cx - c.x - p.x * s, cy - c.y - p.y * s, animate);
    },
    toggleZoom(cx, cy) { if (this.z.s > 1) this.setZoom(1, 0, 0, true); else this.zoomTo(2.5, cx, cy, true); },
    resetZoom() { this.z = { s: 1, tx: 0, ty: 0 }; this.el.classList.remove('is-zoomed'); if (this.media) { this.media.style.transform = ''; this.media.style.transition = ''; } },
    // Kruis in de rechterbovenhoek van de (ongezoomde) foto/video, binnen het scherm
    positionClose() {
      const btn = this.closeBtn; if (!btn || !this.media) return;
      const r = this.media.getBoundingClientRect(), size = btn.offsetWidth || 56, pad = 10;
      const vw = window.innerWidth, vh = window.innerHeight;
      let left = this.z.s > 1 ? vw - size - pad : Math.min(vw - size - pad, r.right - size - pad);
      let top = this.z.s > 1 ? pad : Math.max(pad, r.top + pad);
      if (r.width < size * 3) { left = vw - size - pad; top = pad; }
      btn.style.left = left + 'px'; btn.style.top = top + 'px'; btn.style.right = 'auto';
    },

    collect(trigger) {
      const group = trigger.closest('.look__media') || trigger.parentElement;
      const nodes = Array.from(group.querySelectorAll('[data-stl-zoom]'));
      const items = nodes.map((n) => ({
        kind: n.dataset.stlZoom, src: n.dataset.src, srcset: n.dataset.srcset, type: n.dataset.type, poster: n.dataset.poster,
        width: n.dataset.width, height: n.dataset.height, alt: n.dataset.alt || '', node: n
      })).filter((i) => i.src);
      return { items, index: Math.max(0, items.findIndex((i) => i.node === trigger)), title: group.dataset.lookTitle || '', brands: group.dataset.lookBrands || '', url: group.dataset.lookUrl || '' };
    },

    openFrom(trigger) {
      const data = this.collect(trigger);
      if (!data.items.length) return;
      this.open(data.items, data.index, trigger, data);
    },

    open(items, index, origin, meta) {
      this.build();
      if (this.isOpen) return;
      this.items = items; this.index = index; this.origin = origin; this.meta = meta || {};
      this.lastFocus = document.activeElement;
      this.isOpen = true; this.closing = false;
      // inline video pauzeren zolang de lightbox open is
      this.pausedInline = origin && origin.tagName === 'STL-VIDEO' && origin.video && !origin.video.paused ? origin : null;
      if (this.pausedInline) this.pausedInline.video.pause();

      document.documentElement.classList.add('stl-lightbox-open');
      this.el.hidden = false;
      this.el.style.background = '';
      this.render();
      setTimeout(() => { this.el.setAttribute('open', ''); this.closeBtn.focus({ preventScroll: true }); }, 30);
      clearTimeout(this.hintTimer);
      this.el.removeAttribute('hint-done');
      this.hintTimer = setTimeout(() => this.el.setAttribute('hint-done', ''), 2200);
      try { history.pushState({ stlLightbox: true }, '', location.href); this.pushed = true; } catch (e) { this.pushed = false; }
    },

    render() {
      const item = this.items[this.index];
      if (!item) return;
      this.stage.innerHTML = '';
      let node;
      if (item.kind === 'video') {
        node = document.createElement('video');
        node.controls = true; node.autoplay = true; node.loop = true; node.playsInline = true; node.preload = 'auto';
        node.muted = !(item.node.hasAttribute('unmuted'));
        if (item.poster) node.poster = item.poster;
        if (item.width) node.width = item.width;
        if (item.height) node.height = item.height;
        node.setAttribute('aria-label', item.alt);
        const src = document.createElement('source');
        src.src = item.src; if (item.type) src.type = item.type;
        node.appendChild(src);
        // klik op de video zelf sluit niet (browser regelt play/pause via de controls)
        node.addEventListener('click', (ev) => ev.stopPropagation());
      } else {
        node = document.createElement('img');
        node.src = item.src;
        if (item.srcset) { node.srcset = item.srcset; node.sizes = '100vw'; }
        node.alt = item.alt; node.decoding = 'async'; node.draggable = false;
        if (item.width) node.width = item.width;
        if (item.height) node.height = item.height;
      }
      node.className = 'stl-lightbox__media';
      node.dataset.kind = item.kind;
      this.stage.appendChild(node);
      this.media = node;
      this.resetZoom();
      this.closeBtn.style.left = ''; this.closeBtn.style.top = ''; this.closeBtn.style.right = '';
      const place = () => { if (this.media === node) this.positionClose(); };
      if (item.kind === 'image') { if (node.complete) setTimeout(place, 40); node.addEventListener('load', () => setTimeout(place, 40)); }
      else { node.addEventListener('loadedmetadata', () => setTimeout(place, 40)); setTimeout(place, 80); }
      setTimeout(place, 320);
      if (item.kind === 'video') { const p = node.play(); if (p && p.catch) p.catch(() => {}); }

      const multi = this.items.length > 1;
      this.prevBtn.hidden = !multi; this.nextBtn.hidden = !multi;
      this.countEl.textContent = multi ? (this.index + 1) + ' / ' + this.items.length : '';
      this.titleEl.textContent = this.meta.title || '';
      this.brandsEl.textContent = this.meta.brands || '';
      if (this.meta.url) { this.linkEl.href = this.meta.url; this.linkEl.textContent = 'Bekijk look'; this.linkEl.hidden = false; }
      else { this.linkEl.hidden = true; }
      // buurbeeld alvast laden
      const nxt = this.items[(this.index + 1) % this.items.length];
      if (multi && nxt && nxt.kind === 'image') { const pre = new Image(); pre.src = nxt.src; }
    },

    go(dir) {
      if (!this.isOpen || this.items.length < 2) return;
      this.index = (this.index + dir + this.items.length) % this.items.length;
      this.render();
    },

    close() {
      if (!this.isOpen || this.closing) return;
      this.closing = true;
      if (this.pushed) { this.pushed = false; try { history.back(); } catch (e) {} }
      this.el.removeAttribute('open');
      const finish = () => {
        this.el.hidden = true;
        this.resetZoom();
        this.stage.innerHTML = '';
        this.media = null;
        this.isOpen = false; this.closing = false;
        document.documentElement.classList.remove('stl-lightbox-open');
        if (this.pausedInline) { const v = this.pausedInline; this.pausedInline = null; v.play(); }
        const back = this.origin && this.origin.isConnected ? (this.origin.tagName === 'STL-VIDEO' ? this.origin.querySelector('video') : this.origin) : this.lastFocus;
        if (back && back.focus) back.focus({ preventScroll: true });
      };
      setTimeout(finish, 220);
    }
  };
  window.StlLightbox = Lightbox;

  /* ---------- Shop alles: pop-up met maatkeuze per artikel, hele outfit in één keer in de winkelwagen ---------- */
  const ShopAll = {
    el: null, isOpen: false, items: [], host: null, lastFocus: null, fmt: '€{{amount_with_comma_separator}}',

    money(cents) {
      const f = this.fmt || '€{{amount_with_comma_separator}}';
      const n = (cents || 0) / 100;
      const num = (dec, thou, decimals) => {
        const parts = n.toFixed(decimals).split('.');
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (decimals ? dec + parts[1] : '');
      };
      let out;
      if (f.indexOf('amount_no_decimals_with_comma_separator') > -1) out = num('', '.', 0);
      else if (f.indexOf('amount_no_decimals_with_space_separator') > -1) out = num('', ' ', 0);
      else if (f.indexOf('amount_no_decimals') > -1) out = num('', ',', 0);
      else if (f.indexOf('amount_with_comma_separator') > -1) out = num(',', '.', 2);
      else if (f.indexOf('amount_with_apostrophe_separator') > -1) out = num('.', "'", 2);
      else if (f.indexOf('amount_with_space_separator') > -1) out = num(',', ' ', 2);
      else out = num('.', ',', 2);
      return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, out).replace(/<[^>]+>/g, '');
    },

    build() {
      if (this.el) return;
      const el = document.createElement('div');
      el.className = 'stl-shop-all';
      el.hidden = true;
      el.innerHTML =
        '<div class="stl-shop-all__backdrop"></div>' +
        '<div class="stl-shop-all__panel" role="dialog" aria-modal="true" aria-labelledby="stl-shop-all-heading">' +
          '<div class="stl-shop-all__head">' +
            '<div><p class="stl-shop-all__kicker">Shop alles</p><h3 class="stl-shop-all__heading" id="stl-shop-all-heading"></h3><p class="stl-shop-all__brands"></p></div>' +
            '<button class="stl-shop-all__close" type="button" aria-label="Sluiten">' + ICON_CLOSE + '</button>' +
          '</div>' +
          '<p class="stl-shop-all__intro">Kies per artikel je maat. Wil je iets niet? Vink het uit.</p>' +
          '<ul class="stl-shop-all__list"></ul>' +
          '<div class="stl-shop-all__foot">' +
            '<div class="stl-shop-all__summary"><span class="stl-shop-all__count"></span><span class="stl-shop-all__total"></span></div>' +
            '<button class="add-to-cart-button button w-full stl-shop-all__submit" type="button" style="--button-background: 196 167 125; --button-text-color: 0 0 0;">Alles in winkelwagen</button>' +
            '<p class="stl-shop-all__msg" role="status" aria-live="polite"></p>' +
          '</div>' +
        '</div>';
      document.body.appendChild(el);
      this.el = el;
      this.list = el.querySelector('.stl-shop-all__list');
      this.heading = el.querySelector('.stl-shop-all__heading');
      this.brandsEl = el.querySelector('.stl-shop-all__brands');
      this.countEl = el.querySelector('.stl-shop-all__count');
      this.totalEl = el.querySelector('.stl-shop-all__total');
      this.submit = el.querySelector('.stl-shop-all__submit');
      this.msg = el.querySelector('.stl-shop-all__msg');
      this.closeBtn = el.querySelector('.stl-shop-all__close');

      this.closeBtn.addEventListener('click', () => this.close());
      el.querySelector('.stl-shop-all__backdrop').addEventListener('click', () => this.close());
      this.submit.addEventListener('click', () => this.add());
      this.list.addEventListener('change', (ev) => {
        const row = ev.target.closest('.stl-shop-all__item');
        if (!row) return;
        const item = this.items[Number(row.dataset.i)];
        if (ev.target.matches('input[type="checkbox"]')) item.checked = ev.target.checked;
        if (ev.target.matches('select')) { item.sel[Number(ev.target.dataset.opt)] = ev.target.value; this.resolve(item); this.renderRow(item); }
        this.updateSummary();
      });
      document.addEventListener('keydown', (ev) => {
        if (!this.isOpen) return;
        if (ev.key === 'Escape') { ev.preventDefault(); this.close(); }
        else if (ev.key === 'Tab') {
          const f = Array.from(el.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled])')).filter((n) => n.offsetParent !== null);
          if (!f.length) return;
          const first = f[0], last = f[f.length - 1];
          if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
          else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
        }
      });
    },

    // Variant zoeken die bij de gekozen opties hoort
    resolve(item) {
      const p = item.product;
      item.variant = p.variants.find((v) => v.options.every((o, i) => o === item.sel[i])) || null;
    },

    open(host, opener) {
      this.build();
      if (this.isOpen) return;
      let data = [];
      try { data = JSON.parse(host.querySelector('[data-stl-shop-all-data]').textContent); } catch (e) { data = []; }
      if (!data.length) return;
      this.host = host;
      this.fmt = host.dataset.moneyFormat || this.fmt;
      this.lastFocus = opener || document.activeElement;
      this.items = data.map((product, idx) => {
        const firstAvail = product.variants.find((v) => v.available) || product.variants[0];
        const item = { idx, product, sel: firstAvail ? firstAvail.options.slice() : [], variant: null, checked: !!(firstAvail && firstAvail.available) };
        this.resolve(item);
        return item;
      });
      this.heading.textContent = host.dataset.lookTitle || '';
      this.brandsEl.textContent = host.dataset.lookBrands || '';
      this.msg.textContent = '';
      this.submit.disabled = false; this.submit.textContent = 'Alles in winkelwagen';
      this.list.innerHTML = '';
      this.items.forEach((item) => {
        const li = document.createElement('li');
        li.className = 'stl-shop-all__item';
        li.dataset.i = item.idx;
        this.list.appendChild(li);
        item.row = li;
        this.renderRow(item);
      });
      this.updateSummary();
      this.isOpen = true;
      document.documentElement.classList.add('stl-modal-open');
      this.el.hidden = false;
      setTimeout(() => { this.el.setAttribute('open', ''); this.closeBtn.focus({ preventScroll: true }); }, 30);
    },

    renderRow(item) {
      const p = item.product, v = item.variant;
      const single = p.variants.length === 1 && p.variants[0].title === 'Default Title';
      const soldOut = !p.available;
      const unavailable = !soldOut && (!v || !v.available);
      if (soldOut) item.checked = false;
      const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
      // Alleen de maat is kiesbaar; andere opties (bijv. Kleur) liggen vast op het artikel uit de look
      const visible = [];
      p.options.forEach((name, oi) => { if (/maat|size|grootte|gr\u00f6\u00dfe|taille|lengte|length/i.test(name)) visible.push(oi); });
      let opts = '';
      if (!single && visible.length) {
        opts = visible.map((oi) => {
          const name = p.options[oi];
          const values = [];
          p.variants.forEach((vv) => { if (values.indexOf(vv.options[oi]) === -1) values.push(vv.options[oi]); });
          const options = values.map((val) => {
            // beschikbaar in combinatie met de andere gekozen opties?
            const ok = p.variants.some((vv) => vv.available && vv.options[oi] === val && vv.options.every((o, i) => i === oi || o === item.sel[i]));
            return '<option value="' + esc(val) + '"' + (item.sel[oi] === val ? ' selected' : '') + (ok ? '' : ' data-soldout') + '>' + esc(val) + (ok ? '' : ' – uitverkocht') + '</option>';
          }).join('');
          return '<label class="stl-shop-all__opt"><span>' + esc(name) + '</span><select data-opt="' + oi + '" aria-label="' + esc(name) + '"' + (soldOut ? ' disabled' : '') + '>' + options + '</select></label>';
        }).join('');
      } else if (single || p.variants.length === 1) {
        opts = '<span class="stl-shop-all__opt stl-shop-all__opt--single">Eén maat</span>';
      }
      if (soldOut) opts = '';
      const price = v ? v.price_f : (p.variants[0] ? p.variants[0].price_f : '');
      const compare = v && v.compare_f ? '<s>' + esc(v.compare_f) + '</s> ' : '';
      let note = '';
      if (soldOut) note = 'Uitverkocht';
      else if (unavailable) note = 'Deze maat is uitverkocht – kies een andere maat';
      item.row.className = 'stl-shop-all__item' + (soldOut ? ' is-soldout' : '') + (unavailable ? ' is-unavailable' : '') + (item.checked ? '' : ' is-unchecked');
      item.row.innerHTML =
        '<label class="stl-shop-all__check"><input type="checkbox"' + (item.checked ? ' checked' : '') + (soldOut ? ' disabled' : '') + ' aria-label="' + esc(p.title) + ' meenemen"><span></span></label>' +
        '<a class="stl-shop-all__img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="120" height="160">' : '') + '</a>' +
        '<div class="stl-shop-all__info">' +
          (p.vendor ? '<span class="stl-shop-all__vendor">' + esc(p.vendor) + '</span>' : '') +
          '<a class="stl-shop-all__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<span class="stl-shop-all__price">' + compare + esc(price) + '</span>' +
          '<div class="stl-shop-all__opts">' + opts + '</div>' +
          (note ? '<span class="stl-shop-all__note">' + note + '</span>' : '') +
        '</div>';
    },

    updateSummary() {
      const sel = this.items.filter((i) => i.checked && i.variant && i.variant.available);
      const total = sel.reduce((sum, i) => sum + i.variant.price, 0);
      this.countEl.textContent = sel.length === 1 ? '1 artikel' : sel.length + ' artikelen';
      this.totalEl.textContent = this.money(total);
      this.submit.disabled = sel.length === 0;
      this.items.forEach((i) => { if (i.row) i.row.classList.toggle('is-unchecked', !i.checked); });
    },

    async add() {
      const lines = this.items.filter((i) => i.checked && i.variant && i.variant.available).map((i) => ({ id: i.variant.id, quantity: 1 }));
      if (!lines.length) { this.msg.textContent = 'Kies minimaal één artikel.'; return; }
      this.submit.disabled = true; this.submit.textContent = 'Toevoegen…'; this.msg.textContent = '';
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const settings = (window.themeVariables && window.themeVariables.settings) || {};
      const fire = (name, detail) => document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
      // Zelfde route als het thema zelf (product-form): drawer-sectie mee laten renderen, dan cart:change → drawer ververst en opent
      const sections = new Set();
      fire('cart:prepare-bundled-sections', { sections });
      const body = { items: lines };
      if (sections.size) body.sections = Array.from(sections).join(',');
      fire('theme:loading:start');
      try {
        const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
        const json = await r.json().catch(() => ({}));
        fire('theme:loading:end');
        if (!r.ok) throw new Error(json.description || json.message || 'Toevoegen is niet gelukt. Probeer het opnieuw.');
        this.close();
        if (settings.cartType === 'page' || settings.pageType === 'cart') { window.location.href = root + 'cart'; return; }
        const drawer = document.getElementById('cart-drawer');
        let done = false;
        if (drawer && json.sections && Object.keys(json.sections).length) {
          try {
            const cart = await (await fetch(root + 'cart.js')).json();
            cart.sections = json.sections;
            fire('cart:change', { baseEvent: 'variant:add', cart });
            done = true;
          } catch (e) { done = false; }
        }
        if (!done) {
          fire('cart:refresh');
          if (drawer && typeof drawer.show === 'function') setTimeout(() => drawer.show(), 300);
          else if (!drawer) window.location.href = root + 'cart';
        }
      } catch (e) {
        fire('theme:loading:end');
        this.msg.textContent = e.message || 'Toevoegen is niet gelukt. Probeer het opnieuw.';
        this.submit.disabled = false; this.submit.textContent = 'Alles in winkelwagen';
      }
    },

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.el.removeAttribute('open');
      document.documentElement.classList.remove('stl-modal-open');
      setTimeout(() => { if (!this.isOpen) this.el.hidden = true; }, 220);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    }
  };
  window.StlShopAll = ShopAll;

  document.addEventListener('click', (ev) => {
    const btn = ev.target.closest('[data-stl-shop-all-open]');
    if (!btn) return;
    ev.preventDefault();
    const host = btn.closest('stl-shop-all');
    if (host) ShopAll.open(host, btn);
  });

  // Klik/tik op een foto-zoomknop
  document.addEventListener('click', (ev) => {
    const btn = ev.target.closest('.look__zoom[data-stl-zoom]');
    if (!btn) return;
    ev.preventDefault();
    Lightbox.openFrom(btn);
  });

  // Category filter buttons (overview)
  document.addEventListener('click', (ev) => {
    const btn = ev.target.closest('.look-list__filter[data-filter]');
    if (!btn) return;
    const list = btn.closest('.look-list');
    const value = btn.dataset.filter;
    list.querySelectorAll('.look-list__filter').forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
    let visible = 0;
    list.querySelectorAll('.look[data-category]').forEach((el) => {
      const show = value === '' || el.dataset.category === value;
      el.hidden = !show; if (show) visible++;
    });
    const empty = list.querySelector('.look-list__empty');
    if (empty) empty.hidden = visible > 0;
    try { history.replaceState(null, '', value ? '#' + encodeURIComponent(value) : location.pathname); } catch (e) {}
  });
  // Restore filter from hash
  document.addEventListener('DOMContentLoaded', () => {
    const h = decodeURIComponent(location.hash.replace('#', ''));
    if (!h) return;
    const btn = document.querySelector('.look-list__filter[data-filter="' + CSS.escape(h) + '"]');
    if (btn) btn.click();
  });
})();
